/**
 * Shim for @clariness/button: re-exports with optional placeholder/onPointer* props
 * so React 19 types don't require them (theme-ui Pick<> types treat them as required).
 */
import React from 'react';
import { Button as OrigButton, type ButtonProps } from '~clariness-button';

type OptionalPointerProps = {
  placeholder?: string;
  onPointerEnterCapture?: React.PointerEventHandler;
  onPointerLeaveCapture?: React.PointerEventHandler;
};

export type { ButtonProps };
export const Button = OrigButton as React.ForwardRefExoticComponent<
  Omit<React.ComponentProps<typeof OrigButton>, keyof OptionalPointerProps> &
    OptionalPointerProps &
    React.RefAttributes<HTMLButtonElement>
>;
